import { ref, watch } from '@vue/composition-api'
// import store from '@/store'

export default function useRefCategoryHandler(props, emit) {
    // ------------------------------------------------
    // taskLocal
    // ------------------------------------------------
    const refCategoryLocal = ref(JSON.parse(JSON.stringify(props.category.value)))
    const resetRefCategoryLocal = () => {
      refCategoryLocal.value = JSON.parse(JSON.stringify(props.category.value))
    }
    watch(props.category, () => {
      resetRefCategoryLocal()
    })
  
    // ------------------------------------------------
    // isEventHandlerSidebarActive
    // * Clear form if sidebar is closed
    // ! We can hide it using @hidden event
    // ------------------------------------------------
    // watch(props.isEventHandlerSidebarActive, val => {
    //   // ? Don't reset event till transition is finished
    //   if (!val) {
    //     setTimeout(() => {
    //       clearForm.value()
    //     }, 350)
    //   }
    // })
  
    const onSubmit = () => {
      const refCategoryData = JSON.parse(JSON.stringify(refCategoryLocal))
  
      // * If event has id => Edit Event
      // Emit event for add/update event
      if (props.category.value.id) emit('update-ref-category', refCategoryData.value)
      else emit('add-ref-category', refCategoryData.value)
  
      // Close sidebar
      emit('update:is-add-new-ref-category-sidebar-active', false)
    }
  
  
    return {
      // fetchCategories,
      // fetchProducts,
      // fetchTags,
      // fetchPriorities,
      // fetchTeams,
      // fetchUsers,
      refCategoryLocal,
      resetRefCategoryLocal,
      onSubmit,
    }
  }